<template>
  <div id="success">   
    <BooingSuccessComponent></BooingSuccessComponent>     
  </div>
</template>

<script>

  import BooingSuccessComponent from '@/components/cust_components/booking_success_component.vue';
  
  export default {
      name: 'SuccessView',
      data() {
          return {
          }
      },
      components: {     
        BooingSuccessComponent,
      }
  }
</script>